import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const BookingContext = createContext(null);

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState('https://koalendar.com/u/TAGConsultingLLC');
  const [title, setTitle] = useState('Book a Session');

  const openBooking = useCallback((bookingUrl, bookingTitle) => {
    if (bookingUrl) setUrl(bookingUrl);
    setTitle(bookingTitle || 'Book a Session');
    setOpen(true);
  }, [setUrl, setTitle, setOpen]);

  const closeBooking = useCallback(() => setOpen(false), [setOpen]);

  const value = useMemo(
    () => ({ open, url, title, openBooking, closeBooking }),
    [open, url, title, openBooking, closeBooking]
  );

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};
